import styled from 'styled-components';
import cssValue from './utils/cssValue.js';
const Flex = styled.div.withConfig({
  shouldForwardProp: p => !['reverse', 'column', 'weight', 'wrap', 'align', 'justify', 'center', 'fixed', 'auto'].includes(p)
})`
  display: flex;
  ${({
  onClick
}) => onClick ? 'cursor: pointer;' : ''};
  ${({
  auto
}) => auto ? 'flex: 1 1 auto;' : ''};
  ${({
  fixed
}) => fixed ? 'flex: 0 0 auto' : ''};
  ${({
  center
}) => center ? `justify-content: center; align-items: center;` : ``};
  ${({
  justify
}) => justify ? `justify-content: ${cssValue(justify)};` : ''};
  ${({
  align
}) => align ? `align-items: ${cssValue(align)};` : ''};
  ${({
  wrap
}) => wrap ? `flex-wrap: ${cssValue(wrap)};` : ''};
  ${({
  weight
}) => weight ? `flex: ${cssValue(weight)};` : ''};
  flex-direction: ${({
  column,
  reverse
}) => column ? `column${reverse ? '-reverse' : ''}` : `row${reverse ? '-reverse' : ''}`};
`;
export { Flex as default };
//# sourceMappingURL=Flex.js.map
